import {hoistCmp, uses} from '@xh/hoist/core';
import {SecurityEditModel} from './SecurityEditModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {form} from '@xh/hoist/cmp/form';
import {formField} from '@xh/hoist/desktop/cmp/form';
import {numberInput, select, textInput} from '@xh/hoist/desktop/cmp/input';
import {filler, hbox, vframe} from '@xh/hoist/cmp/layout';
import {countryCodes, currencyCodes, exchanges, industries, sectors} from '../../../DomainData';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {Icon} from '@xh/hoist/icon';
import {secTypeBadge} from '../../../../../cmp/secBadges/SecBadges';

export const securityEdit = hoistCmp.factory<SecurityEditModel>({
    model: uses(SecurityEditModel),
    render({model}) {
        return panel({
            tbar: toolbar({
                compact: true,
                items: [
                    'General security attributes',
                    filler(),
                    button({
                        icon: Icon.check(),
                        intent: 'success',
                        tooltip: 'Save',
                        disabled: !(model.isVlid && model.hasChanges),
                        onClick: () => model.save()
                    }),
                    button({
                        icon: Icon.undo(),
                        intent: 'warning',
                        tooltip: 'revert',
                        disabled: !(model.isVlid && model.hasChanges),
                        onClick: () => model.revert()
                    })
                ]
            }),
            item: editForm()
        });
    }
});

const editForm = hoistCmp.factory<SecurityEditModel>(({model}) => {
    const {type, subType} = model.security;

    return vframe({
        className: 'security-edit-form',
        item: form({
            fieldDefaults: {
                inline: true,
                minimal: true,
                commitOnChange: true,
                labelTextAlign: 'right',
                labelWidth: 100
            },
            items: [
                hbox(
                    formField({
                        field: 'type',
                        item: type
                            ? secTypeBadge(type)
                            : select({options: model.typeOptions, enableFilter: false, width: 150})
                    }),
                    formField({
                        field: 'subType',
                        item: subType
                            ? secTypeBadge(subType)
                            : select({
                                  options: model.subTypeOptions,
                                  enableFilter: false,
                                  width: 150
                              })
                    })
                ),
                formField({field: 'name', item: textInput()}),
                hbox(
                    formField({field: 'ticker', item: textInput(), width: 300}),
                    formField({
                        field: 'exchange',
                        item: select({options: exchanges, enableCreate: true}),
                        width: 300
                    })
                ),
                hbox(
                    formField({field: 'isin', item: textInput(), width: 300}),
                    formField({field: 'cusip', item: textInput(), width: 300})
                ),
                hbox(
                    formField({
                        field: 'country',
                        label: 'Country Code',
                        item: select({options: countryCodes, enableCreate: true}),
                        width: 300
                    }),
                    formField({
                        field: 'currency',
                        item: select({options: currencyCodes, enableCreate: true}),
                        width: 300
                    })
                ),
                hbox(
                    formField({
                        field: 'sector',
                        item: select({options: sectors.sort(), menuWidth: 300}),
                        width: 300
                    }),
                    formField({
                        field: 'industry',
                        item: select({options: industries.sort(), menuWidth: 350}),
                        width: 300
                    })
                ),
                hbox(
                    formField({field: 'beta', item: numberInput(), width: 300}),
                    formField({field: 'lastDividend', item: numberInput(), width: 300})
                )
            ]
        })
    });
});
